import { Add, ExpandLess, ExpandMore, LockOpen } from '@mui/icons-material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {
  Box,
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { MuiRTL } from 'lib/MuiRTL';
import { Fragment } from 'react';

const DockSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="بارانداز" />
    </ListItemButton>
  );
};

const ProductListSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="لیست محصول" />
    </ListItemButton>
  );
};

const ShoppingCartsSidebarItem = ({
  carts,
  expanded,
  selectedCartGuid,
  onToggle,
  onSelectCart,
  onAddNewShoppingCart,
  canAddCart,
}) => {
  return (
    <Fragment>
      <ListItemButton onClick={onToggle}>
        <ListItemText primary="لیست سبدها" />
        {canAddCart ? (
          <IconButton
            size="small"
            edge="end"
            aria-label="افزودن سبد جدید"
            onClick={event => {
              event.stopPropagation();
              onAddNewShoppingCart?.();
            }}
          >
            <Add fontSize="small" />
          </IconButton>
        ) : null}
        {carts.length > 0 ? expanded ? <ExpandLess /> : <ExpandMore /> : null}
      </ListItemButton>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {carts.length > 0 ? (
            carts.map(cart => (
              <ListItemButton
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  pl: 4,
                }}
                key={cart.guid}
                selected={selectedCartGuid === cart.guid}
                onClick={() => onSelectCart(cart)}
              >
                <ListItemText primary={cart.title} />
                {cart.isLocked ? (
                  <LockIcon fontSize="small" color="inherit" />
                ) : (
                  <LockOpenIcon fontSize="small" color="disabled" />
                )}
              </ListItemButton>
            ))
          ) : (
            <Typography
              variant="body2"
              color="text.disabled"
              textAlign="center"
              py={2}
            >
              سبدی انتخاب نشده است
            </Typography>
          )}
        </List>
      </Collapse>
    </Fragment>
  );
};

export const WorkspaceSidebar = ({
  workspace,
  expandedCarts,
  selectedSection,
  onSelectSidebarItem,
  onToggleCarts,
  onAddNewShoppingCart,
  canAddCart = true,
}) => {
  const carts = workspace?.shoppingCartList || [];

  return (
    <Box sx={{ width: '220px' }}>
      <MuiRTL>
        <List
          dir="rtl"
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <DockSidebarItem
            active={selectedSection.type === 'dock'}
            onClick={() => onSelectSidebarItem('dock')}
          />

          <ProductListSidebarItem
            active={selectedSection.type === 'productList'}
            onClick={() => onSelectSidebarItem('productList')}
          />

          <ShoppingCartsSidebarItem
            carts={carts}
            expanded={expandedCarts}
            selectedCartGuid={
              selectedSection.type === 'cart' ? selectedSection.guid : null
            }
            onToggle={onToggleCarts}
            onSelectCart={cart => onSelectSidebarItem('cart', cart)}
            onAddNewShoppingCart={onAddNewShoppingCart}
            canAddCart={canAddCart}
          />
        </List>
      </MuiRTL>
    </Box>
  );
};
